module.exports = __webpack_public_path__ + "img/hero-lg.bc714586.png";